<template>
  <main class="container">
    <section class="search-section">
      <h1>PODEMOS TE AJUDAR?</h1>
      <SearchField />
    </section>
    <section class="knowledge-base">
      <section class="categories blocks">
        <ul class="blocks-list">
          <BlockItem
            v-for="(categoria,index) in categorias"
            :key="index"
            :categoryId="index"
            :categoria="categoria"
            :site="$parent.site"
          />
        </ul>
      </section>
    </section>
    <RequestSection :telefone="telefone" :atendimento="atendimento" :chat="chat"/>
  </main>
</template>
<script>
import { configs } from "@/assets/data/data.json";
import BlockItem from "@/components/BlockItem";
import RequestSection from "@/components/RequestSection";
import SearchField from "@/components/SearchField";

export default {
  name: "Main",
  components: {
    BlockItem,
    RequestSection,
    SearchField
  },
  data: function() {
    return {
      categorias: "",
      telefone: configs[this.$parent.site].telefone,
      chat: configs[this.$parent.site].chat,
      atendimento: configs[this.$parent.site].atendimento,
    };
  },
  created() {
    this.getSite();
  },
  methods: {
    getSite() {
      this.categorias = configs[this.$parent.site].categorias;
    }
  }
};
</script>
<style lang="scss">
.main {
  margin-top: 50px;
}
.search-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 56px 0 24px;
}

.search {
  border: 1px solid #ffffff;
  background-color: #ffffff;
  box-sizing: border-box;
  width: 100%;
  height: 50px;
  font-weight: 300;
  color: #999;
  font-size: 15px;
  padding-left: 20px;
  padding-right: 40px;
  -webkit-appearance: none;
  outline: none;
}

.search:focus,
.search:active {
  border: 1px solid rgba(0, 0, 0, 1);
}

.blocks-list > * {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style: none;
  padding: 0;
}

.search-section h1 {
  color: rgba(0, 0, 0, 1);
  font-size: 35px;
  text-transform: uppercase;
  text-align: center;
}

@media screen and (min-width: 768px) {
  .blocks-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    list-style: none;
    padding: 0;
  }

  .block-item {
    background-color: #ffffff;
    box-sizing: border-box;
    color: rgba(0, 0, 0, 1);
    display: flex;
    flex: 1 0 220px;
    flex-direction: column;
    justify-content: center;
    margin: 0 0px 20px 0;
    max-width: 220px;
    width: 100%;
    height: 280px;
    text-align: center;
    transition: all 300ms ease;
  }

  .search-section h1 {
    font-weight: 700;
    color: rgba(0, 0, 0, 1);
    font-size: 35px;
    text-transform: uppercase;
    text-align: center;
  }
}

@media screen and (min-width: 768px) {
  .blocks-list {
    margin: 0 64px;
  }
}
.blocks-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  list-style: none;
  padding: 0;
}
/* Breakpoint mobile */
@media screen and (max-width: 767px) {
  .blocks-list {
    justify-content: space-between;
  }
}

/* mobile L */

@media (max-width: 560px) {
  .search-section h1 {
    font-size: 28px;
  }
}
/* mobile M */
@media (max-width: 379px) {
  .search-section h1 {
    font-size: 24px;
  }
}
/* mobile S */
</style>
